import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["remindModal"]
  static values = {
    currentPage: { type: Number, default: 1 },
    totalPages: { type: Number, default: 1 }
  }

  connect() {
    // Initialize participants controller
  }

  // Pagination methods
  previousPage() {
    if (this.currentPageValue > 1) {
      this.currentPageValue--
      this.loadPage(this.currentPageValue)
    }
  }

  nextPage() {
    if (this.currentPageValue < this.totalPagesValue) {
      this.currentPageValue++
      this.loadPage(this.currentPageValue)
    }
  }

  goToPage(event) {
    const page = parseInt(event.currentTarget.dataset.page, 10)
    if (page && page !== this.currentPageValue) {
      this.currentPageValue = page
      this.loadPage(page)
    }
  }

  loadPage(page) {
    // In a real implementation, this would fetch data from the server
    // For now, we'll just update the URL and potentially use Turbo
    const url = new URL(window.location)
    url.searchParams.set("page", page)
    window.history.pushState({}, "", url)

    // Optionally trigger a Turbo visit
    // Turbo.visit(url, { action: "replace" })
  }

  // Modal methods
  openRemindModal(event) {
    const participantId = event.currentTarget.dataset.participantId
    const participantName = event.currentTarget.dataset.participantName
    const participantEmail = event.currentTarget.dataset.participantEmail

    // Find the remind modal controller and open it with participant data
    const remindModalElement = this.remindModalTarget
    if (remindModalElement) {
      const remindModalController = this.application.getControllerForElementAndIdentifier(
        remindModalElement,
        "remind-modal"
      )
      if (remindModalController) {
        remindModalController.openWithData({
          id: participantId,
          name: participantName,
          email: participantEmail
        })
      }
    }
  }

  viewParticipant(event) {
    const participantId = event.currentTarget.dataset.participantId
    // Navigate to participant detail view or open a side panel
    // Turbo.visit(`/participants/${participantId}`)
  }

  // Table actions
  selectAll(event) {
    const isChecked = event.currentTarget.checked
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"][name^="participant_"]')
    checkboxes.forEach(checkbox => {
      checkbox.checked = isChecked
    })
  }

  getSelectedParticipants() {
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"][name^="participant_"]:checked')
    return Array.from(checkboxes).map(cb => cb.name.replace('participant_', ''))
  }
}
